import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=5d2e1e60&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=5d2e1e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2e1e60",
  null
  
)

export default component.exports